import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSonUser } from "@/api/auth/onlineUser";
import { Message } from "element-ui";
import addUser from "./components/addUser";
import { mapActions } from "vuex";
import rolead from "./components/rolead";
export default {
  name: "subaccount",
  components: {
    addUser: addUser,
    rolead: rolead
  },
  data: function data() {
    return {
      tableData: [],
      addUser: false,
      total: 0,
      page: 1,
      showing: false,
      current_page: 1,
      searchData: {
        page: 1,
        page_size: 10
      }
    };
  },
  activated: function activated() {
    this.getData(this.searchData.page);
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["usersList", "disableUser", "delUser"])), {}, {
    handleSource: function handleSource(id) {
      var _this = this;

      // 添加、修改
      this.addUser = true;
      this.showing = true;
      this.$nextTick(function () {
        _this.$refs.addUser.init(id);
      });
    },
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.searchData.page = e;
                _context.next = 3;
                return getSonUser(_this2.searchData);

              case 3:
                query = _context.sent;
                _this2.tableData = query.data.data;
                _this2.total = query.data.total;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    handleDisable: function handleDisable(id) {
      var _this3 = this;

      this.disableUser({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this3.getData(_this3.searchData.page);
        } else {
          Message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.delUser({
                  id: id
                });

              case 2:
                _this4.getData(_this4.searchData.page);

                _this4.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  })
};